import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { getCode } from 'app/utils/method';
import { debounceTime, distinctUntilChanged, firstValueFrom, ReplaySubject, Subject, Subscription, take, takeUntil } from 'rxjs';
import { PaymentOrderService } from './payment-management.service';
import { MatSort, MatSortModule } from '@angular/material/sort';
import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { OrderPaymentAttributesExt } from '../dto/payment-management.interface';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MatOptionModule, MatPseudoCheckboxModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { DateHourPipe } from 'app/pipes/formated-date.pipe';
import { ImageCarouselComponent } from '../../reports/visits/visit-report/modal-image/modal-image.component';
import { MonedaPipe } from 'app/pipes/moneda.pipe';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { FormApproRejectComponent } from '../../shared/form-appro-reject/form-appro-reject.component';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { BankAttributes, CompanyAttributes, DocumentClassAttributes, PaymentMethodsAttributes, PaymentTypeAttributes, SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTabsModule } from '@angular/material/tabs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CompanyService } from '../../configuration/company/company.service.service';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { DocumentClassService } from '../../document/document-class/document-class.service';
import { ActionApplicationEnum } from '@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/action-application.enum';
import { ORDER_PAYMENT_LIST_TITLE } from 'app/modules/components/collections/export/order-payment-c-list.constants';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { OrderPaymentExportC } from 'app/modules/components/collections/export/order-payment-c-list.export';
import { TypeRejectEnum } from '../../shared/form-appro-reject/type-document.enum';
import { validateOrdersByActionForPayment } from 'app/utils/document-class-validation';
import { OrderPaymentIntegratosServicesService } from './payment-management-integrator.service';
import { Router } from '@angular/router';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { LogModalComponent } from 'app/modules/shared/log-modal/log-modal.component';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { IRequestResult } from 'app/common/interfaces';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import { PaymentMethodService } from '../../payment-master/payment-method/payment-method.service';
import { PaymentTypeService } from '../../payment-master/payment-type/payment-type.service';
import { BankService } from '../../payment-master/bank/bank.service';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { DatesFiltersComponent } from '../../filters/dates-filters/dates-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { RoutesFiltersComponent } from '../../filters/routes-filters/routes-filters.component';
import { BusinessPartnersFiltersComponent } from '../../filters/business-partners-filters/business-partners-filters.component';
import { FinanceFiltersComponent } from '../../filters/finance-filters/finance-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from 'app/utils/date.helper';
import { CollectionService } from './payment-pdf-generator.service';
import { InvoicePdfOptions } from '../../sales/invoice-list/Print/invoice-pdf-options.interface';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';


@Component({
  selector: "app-payment-management",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MonedaPipe,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormatOtherDateHourPipe,
    FormsModule,
    MatBadgeModule,
    MatTabsModule,
    //DateHourPipe,
    NgxMatSelectSearchModule,
    FilterComponent,
    MatPseudoCheckboxModule,
    MatButtonToggleModule,
    MatChipsModule,
    FilterSectionComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    StatusFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    OrderPaymentExportC,
    provideNativeDateAdapter(),
  ],
  templateUrl: "./payment-management.component.html",
  styleUrl: "./payment-management.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class PaymentManagementComponent implements OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    "det",
    "trip",
    "routeUser",
    "date",
    "documents_count",
    "totalPayingAmount",
    "totalPayingRealAmount",
    "totalPayingEfectiveAmount",
    "amountNotVerified",
    "paymentReviewPercentage",
    "paymentReviewPercentageERP",
  ];

  dataSource: OrderPaymentAttributes[] = [];
  documentClassList: DocumentClassAttributes[] = [];
  totalItems = 0;
  search: string = "";
  pageSize = 50;
  pageIndex = 1;
  sortActive = null;
  sortDirection = "asc";

  searchQuery: string = "";

  isGlobalSynchronizeAvailable: boolean = false;
  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  currency: string = "";
  companyList: CompanyAttributes[] = [];
  selectedPay: any | null = null;
  selectedDetail: any | null = null;
  selectedInner: any | null = null;
  displayedColumnsDetail: string[] = [
    "expandable",
    "select",
    "paymentImages",
    "paymentReview",
    "status",
    "payment_status",
    "shipTo",
    "serial",
    "dateHour",
    "totalAmount",
    "action",
  ];
  displayedColumnsInnerDetail: string[] = [
    "inner",
    "paymentMethod",
    "bank",
    "operationNumber",
    "paying",
  ];
  displayedColumnsDocument: string[] = [
    "serials",
    "paymentType",
    "document",
    "afecto",
    "pendingPayment",
    "paying",
    "balance",
  ];
  displayedColumnsShip: string[] = ["paymentType", "document", "paying"];
  dataSourceDetail = new MatTableDataSource<OrderPaymentAttributes>([]);
  dataSourceInnerDetail = new MatTableDataSource<OrderPaymentAttributes>([]);
  dataSourceShip = new MatTableDataSource<OrderPaymentAttributes>([]);
  dataSourceDocument = new MatTableDataSource<OrderPaymentAttributes>([]);
  // Datos de ejemplo para probar la tabla interna

  selection = new SelectionModel<any>(true, []);
  subRouteList: SubRouteAttributes[] = [];

  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<SubRouteAttributes[]> = new FormControl<
    SubRouteAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<SubRouteAttributes[]> =
    new ReplaySubject<SubRouteAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: SubRouteAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  rangeTripStart = new FormGroup({
    startTripStart: new FormControl<Date | null>(null),
    endTripStart: new FormControl<Date | null>(null),
  });

  rangeTripEnd = new FormGroup({
    startTripEnd: new FormControl<Date | null>(null),
    endTripEnd: new FormControl<Date | null>(null),
  });

  businessPartnerList: BusinessPartnerAttributes[] = [];
  searchBusiness = ''
  private searchSubjectBusiness = new Subject<string>();

  /** control for the selected route for multi-selection */
  public businessPartners: FormControl<BusinessPartnerAttributes[]> = new FormControl<
    BusinessPartnerAttributes[]
  >([]);

    /** list of company filtered by search keyword */
  public filteredCompany: ReplaySubject<CompanyAttributes[]> = new ReplaySubject<
    CompanyAttributes[]
  >(1);

   selectedCompanyIds: string[] = [];

  //Codigo de Documento de pago
  paymentCode = "DT008";
  allowedActions: Set<string> = new Set();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;

  //Para filtros
  selectedStatuses: number[] = [];

  statusOptions = [
    { value: 0, label: 'Anulado', icon: 'heroicons_solid:x-circle', color: 'rgb(141, 19, 19)' },
    { value: 6, label: 'En progreso', icon: 'heroicons_solid:play-circle', color: 'rgb(236, 199, 58)' },
    { value: 7, label: 'Aceptado', icon: 'heroicons_solid:check-circle', color: 'rgb(9, 133, 50)' },
    { value: 8, label: 'Rechazado', icon: 'heroicons_solid:x-circle', color: 'rgb(255, 0, 0)' }
  ];

  // Estados ERP
  selectedERPStatuses: number[] = [];
  erpStatusOptions = [
    { value: 4, label: 'Error en ERP', icon: 'heroicons_solid:exclamation-triangle', color: 'rgb(255, 0, 0)' },
    { value: 1, label: 'Enviado a ERP', icon: 'heroicons_solid:document-arrow-up', color: 'rgb(65, 106, 218)' },
    { value: 0, label: 'Pendiente envío a ERP', icon: 'heroicons_solid:clock', color: 'rgb(233, 124, 61)' },
    { value: 3, label: 'Creado en ERP', icon: 'heroicons_solid:document-check', color: 'rgb(9, 133, 50)' }
  ];

  paymentMethodFilterList: PaymentMethodsAttributes[] = [];

   /** control for the selected route for multi-selection */
  public methodMultiCtrl: FormControl<PaymentMethodsAttributes[]> = new FormControl<
    PaymentMethodsAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public methodMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredMethod: ReplaySubject<PaymentMethodsAttributes[]> =
    new ReplaySubject<PaymentMethodsAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredMethodCache: PaymentMethodsAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateMethod = false;
  isCheckedMethod = false;


  paymentTypeList: PaymentTypeAttributes[] = [];

   /** control for the selected route for multi-selection */
  public typeMultiCtrl: FormControl<PaymentTypeAttributes[]> = new FormControl<
    PaymentTypeAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public typeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredType: ReplaySubject<PaymentTypeAttributes[]> =
    new ReplaySubject<PaymentTypeAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredTypeCache: PaymentTypeAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateType = false;
  isCheckedType = false;


  bankList: BankAttributes[] = [];

   /** control for the selected route for multi-selection */
  public bankMultiCtrl: FormControl<BankAttributes[]> = new FormControl<
    BankAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredBank: ReplaySubject<BankAttributes[]> =
    new ReplaySubject<BankAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredBankCache: BankAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateBank = false;
  isCheckedBank = false;

  form: FormGroup;

  loadConfigData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;

  @ViewChild('collectionPdfDialog') collectionPdfDialog!: TemplateRef<any>;
  collectionForm!: FormGroup;
  selectedElement: any = null;

  constructor(
    private paymentOrderService: PaymentOrderService,
    private readonly companyService: CompanyService,
    private readonly paymentIntegratorService: OrderPaymentIntegratosServicesService,
    private subRouteService: SubRouteService,
    private documentclassService: DocumentClassService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private decimalPipe: DecimalPipe,
    private orderPaymentListExport: OrderPaymentExportC,
    private readonly businessService: BusinessPartnerService,
    private readonly searchService: SearchService,
    private readonly router: Router,
    private fb: FormBuilder,
    private readonly paymentMethodService: PaymentMethodService,
    private readonly paymentTypeService: PaymentTypeService,
    private readonly bankService :  BankService,
    private readonly collectionService: CollectionService,
  ) {

    const today = new Date();
    this.range = this.fb.group({
      start: [today],
      end: [today]
    });

    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      end_startTrip: [],
      end_endTrip: [],
      companyId: [],
      subRouteId: [],
      customerId: [[]],
      paymentTypeId: [[]],
      paymentMethodId: [[]],
      bankId: [[]]
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  loadFinanceData = false;

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    // this.fetchAllRoutes();
    this.getCompanies();
    this.fetchAllDocumentClass();
    this.setupBusinessSearchControl();    
  }
  
  onFinanceExpanded(): void {
    if(!this.loadFinanceData){
      this.fetchAllPaymentMethod();
      this.fetchAllPaymentType();
      this.fetchAllBank()
    }
    this.loadFinanceData = true;
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }

   changueOptionsBusiness(event) {
        this.searchSubjectBusiness.next(event)
    }

  private getAllBusinessPartner(): void {
    const materialOptions = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessService.findToComboBoxCustomer(
      materialOptions,
      [],
      []
    ).subscribe({
      next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
        this.businessPartnerList = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener socios de negocios.","Cerrar",{ duration: 5000});
      },
    })
  }


  getColumns() {
    if (!this.isActionAllowed('SYNC')) {
      this.displayedColumnsDetail = this.displayedColumnsDetail.filter(col => col !== 'select');
    }
  }

  private fetchAllDocumentClass(): void {
    this.documentclassService.findToComboBox().subscribe({
      next: (res) => {
        this.documentClassList = res.data;
        for (let doc of this.documentClassList) {
          if (doc.documentType.code === this.paymentCode) {
            const webApplications = doc.actionsRequirements
              .flatMap(requirement => requirement)
              .filter(app => app.applications.includes((ActionApplicationEnum.WEB)));

            webApplications.forEach(action => {
              this.allowedActions.add(action.action);
            });
          }
        }
        this.getColumns();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener clases de documentos.","Cerrar",{ duration: 5000});
      },
    });
  }

  // Función para validar si la acción está permitida
  public isActionAllowed(action: string, detail?: any): boolean {
    if (!this.allowedActions.has(action)) {
      return false;
    }
    return true;
  }

  private getCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.filteredCompany.next(this.companyList);
      this.currency = this.companyList[0].currencyBase.code;
    });
  }

  

  // Función que determina si una fila es la principal
  isMainRow(element: any): boolean {
    return this.selectedPay?.trip?._id === element?.trip?._id;
  }

  isShipRow(detail: any): boolean {
    // Devuelve true si document está presente y no es una cadena vacía
    return (
      this.selectedDetail?.shipToExternalKeyCode ===
      detail?.shipToExternalKeyCode
    );
  }

  toggleRow(detail: any): void {
    if (
      this.selectedDetail &&
      this.selectedDetail?.serials === detail?.serials
    ) {
      this.selectedDetail = null; // Colapsar la fila si ya está expandida
    } else {
      this.selectedDetail = detail; // Expandir la fila
      this.onFilterDetail(detail); // Filtrar los datos para la tabla anidada
      this.cdr.detectChanges();
    }
  }

  toggleInner(detail: any): void {
    if (this.selectedInner && this.selectedInner?.id === detail?.id) {
      this.selectedInner = null;
    } else {
      this.selectedInner = detail;
      this.onFilterDetailInner(detail);
    }
  }

  //#region COMBO BOX PAYMENT METHOD

  private fetchAllPaymentMethod(): void {
    this.paymentMethodService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentMethodFilterList = res.data;
        this.filteredMethod.next(this.paymentMethodFilterList);

        // listen for search field value changes
        this.methodMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterMethodMulti();
            this.setToggleAllCheckboxStateMethod();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener metodos de pago.","Cerrar",{ duration: 5000});
      },
    });
  }

    protected filterMethodMulti() {
    if (!this.paymentMethodFilterList) {
      return;
    }
    // get the search keyword
    let search = this.methodMultiFilterCtrl.value;
    if (!search) {
      this.filteredMethodCache = this.paymentMethodFilterList;
      this.filteredMethod.next(this.paymentMethodFilterList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredMethodCache = this.paymentMethodFilterList.filter((payment) => {
      const nameMatches = payment.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        payment?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredMethod.next(this.filteredMethodCache);
  }

  toggleSelectAllMethod(selectAllValue: boolean) {
    this.filteredMethod
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.methodMultiCtrl.patchValue(val);
        } else {
          this.methodMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateMethod() {
    let filteredLength = 0;
    if (this.methodMultiCtrl && this.methodMultiCtrl.value) {
      this.filteredMethodCache.forEach((el) => {
        if (this.methodMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateMethod =
        filteredLength > 0 && filteredLength < this.filteredMethodCache.length;
      this.isCheckedMethod =
        filteredLength > 0 && filteredLength === this.filteredMethodCache.length;
    }
  }
  //#endregion
  //#region COMBO BOX PAYMENT TYPE
  
  private fetchAllPaymentType(): void {
    this.paymentTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentTypeList = res.data;
        this.filteredType.next(this.paymentTypeList)
        // listen for search field value changes
        this.typeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterTypeMulti();
            this.setToggleAllCheckboxStateType();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener los tipos de pago.","Cerrar",{ duration: 5000});
      },
    });
  }

    protected filterTypeMulti() {
    if (!this.paymentTypeList) {
      return;
    }
    // get the search keyword
    let search = this.typeMultiFilterCtrl.value;
    if (!search) {
      this.filteredTypeCache = this.paymentTypeList;
      this.filteredType.next(this.paymentTypeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredTypeCache = this.paymentTypeList.filter((payment) => {
      const nameMatches = payment.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        payment?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredType.next(this.filteredTypeCache);
  }

  toggleSelectAllType(selectAllValue: boolean) {
    this.filteredType
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.typeMultiCtrl.patchValue(val);
        } else {
          this.typeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateType() {
    let filteredLength = 0;
    if (this.typeMultiCtrl && this.typeMultiCtrl.value) {
      this.filteredTypeCache.forEach((el) => {
        if (this.typeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateType =
        filteredLength > 0 && filteredLength < this.filteredTypeCache.length;
      this.isCheckedType =
        filteredLength > 0 && filteredLength === this.filteredTypeCache.length;
    }
  }
  //#endregion 

    //#region COMBO BOX BANK
  
  private fetchAllBank(): void {
    this.bankService.findToComboBox().subscribe({
      next: (res) => {
        this.bankList = res.data;
        this.filteredBank.next(this.bankList)

        // listen for search field value changes
        this.bankMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterBankMulti();
            this.setToggleAllCheckboxStateBank();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener bancos.","Cerrar",{ duration: 5000});
      },
    });
  }

    protected filterBankMulti() {
    if (!this.bankList) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBankCache = this.bankList;
      this.filteredBank.next(this.bankList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredBankCache = this.bankList.filter((bank) => {
      const nameMatches = bank.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        bank?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredBank.next(this.filteredBankCache);
  }

  toggleSelectAllBank(selectAllValue: boolean) {
    this.filteredBank
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateBank() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBankCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateBank =
        filteredLength > 0 && filteredLength < this.filteredBankCache.length;
      this.isCheckedBank =
        filteredLength > 0 && filteredLength === this.filteredBankCache.length;
    }
  }
  //#endregion 
  private fetchAllRoutes(): void {
    this.subRouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRouteList = res.data;
        this.filteredRoutes.next(this.subRouteList);

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxStateRoute();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rutas.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterRouteMulti() {
    if (!this.subRouteList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.subRouteList;
      this.filteredRoutes.next(this.subRouteList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredRouteCache = this.subRouteList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateRoute() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  // findAllWithCount(){
  //   this.range.valueChanges.subscribe((rangeValues) => {
  //     this.filter.dateini = rangeValues.start || this.filter.dateini;
  //     this.filter.dateend = rangeValues.end || this.filter.dateend;
  //   });
  //   const adjustedStart = new Date(this.filter.dateini);
  //   adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

  //   const adjustedEnd = new Date(this.filter.dateend);
  //   adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

  //   let date = {
  //     start: adjustedStart.toISOString(), // Convertir a UTC
  //     end: adjustedEnd.toISOString(), // Convertir a UTC
  //   };

  //   const pageIndex = this.paginator.pageIndex + 1;
  //   const sortField = this.getSortFieldByTrip() as keyof OrderPaymentAttributes;
  //   const sortDirection: "ASC" | "DESC" =
  //     this.sort.direction === "asc" ? "ASC" : "DESC";
  //   const routeIds = this.routeMultiCtrl.value.map(
  //     (sub: SubRouteAttributes) => sub.id
  //   );
  //   this.paymentOrderService
  //     .getPaginatePayment(
  //       {
  //         currentPage: pageIndex,
  //         limitPerPage: this.pageSize,
  //         search: this.searchQuery,
  //         sort: sortField,
  //         sortDirection: sortDirection,
  //       },
  //       date,
  //       routeIds
  //     )
  //     .subscribe((data) => {
  //       this.dataSource = data?.data?.[0]?.data ?? [];
  //       this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
  //       this.paginator.length = this.totalItems;
  //     });
  // }

  async findAllWithCount(): Promise<void> {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortFieldByTrip() as keyof OrderPaymentAttributes;
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const routeIds = this.form.get('subRouteId')?.value;

    let date = {
      start: DateHelper.getStartOfDay(this.form.get("start")?.value),
      end: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null
    };  

    let dataFilter = {
      paymentTypeIds: this.form.get("paymentTypeId")?.value,
      paymentMethodIds: this.form.get("paymentMethodId")?.value,
      bankIds: this.form.get("bankId")?.value,
      businessIds: this.form.get("customerId")?.value,
      tripStart: {tripStart: DateHelper.getStartOfDay(this.form.get("startTrip")?.value), tripEnd: DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ?? null},
      tripEnd:  {startTripEnd: DateHelper.getStartOfDay(this.form.get("end_startTrip")?.value) ,endTripEnd: DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ?? DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ?? null},
      }

    try {
      const data = await firstValueFrom(this.paymentOrderService.getPaginatePayment(
        {
          currentPage: pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        date,
        routeIds,
        this.selectedStatuses,
        this.selectedERPStatuses,
        dataFilter
      ));

      this.dataSource = data?.data?.[0]?.data ?? [];
      this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      this.paginator.length = this.totalItems;

    } catch (error) {
      this.snackBar.open(error.error.message || 'Error al obtener los cobros generados.',"Cerrar",{ duration: 5000});
    }
  }

    public totoUTCISODate(date: Date, isStartOfDay: boolean): string {
    const localDate = new Date(date);

    if (isStartOfDay) {
      localDate.setHours(0, 0, 0, 0);
    } else {
      localDate.setHours(23, 59, 59, 999);
    }

    return localDate.toISOString();
  }


  openImageCarousel(images: any[]) {
    const imageLinks = images.map((image) => image.image.link);
    const dialogRef = this.dialog.open(ImageCarouselComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: { images: imageLinks },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  // onFilter(){
  //   const sortField = this.getSortField();
  //   const sortDirection: "ASC" | "DESC" = this.sortDirection === "asc" ? "ASC" : "DESC";

  //   let options = {
  //     currentPage: this.pageIndex,
  //     limitPerPage: this.pageSize,
  //     search: this.search,
  //     sort: sortField,
  //     sortDirection: sortDirection
  //   }

  //   let dataFilter = {
  //     //type: 'DT002', //Pedidos,
  //     startDate: new Date(this.filter.dateini).toISOString(),
  //     endDate: new Date(new Date(this.filter.dateend).setHours(23, 59, 59, 999)).toISOString(),
  //     /*documentClass: this.selectedDocumentClass,
  //     seller: this.selectedSeller.toString(),
  //     withTravel: this.selectedWithTravel,
  //     statusERP: this.selectedStatusERP,*/
  //   }
  //   this.paymentOrderService.findAllWithCount(options, dataFilter).subscribe({
  //     next: (res: IPaginationResult<OrderPaymentAttributesExt>) => {
  //       this.dataSource.data = res?.data?.[0]?.data ?? [];
  //       this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
  //     },
  //     error: (err) => {
  //     },
  //   })
  // }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
      this.closeDetails();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
          this.closeDetails();
        }
      });
  }

  private getSortFieldByTrip(): keyof OrderPaymentAttributesExt {
    const sortFieldMapping: Record<string, keyof OrderPaymentAttributesExt> = {
      shipTo: <any>"shipTo.name",
      user: <any>"user.user_login.username",
      trip: <any>"trip.id",
      balance: <any>"balance",
      amount: <any>"amount",
      date: "dateHour",
    };
    return sortFieldMapping[this.sortActive] || "dateHour";
  }

  private getSortField(): keyof OrderPaymentAttributesExt {
    const sortFieldMapping: Record<string, keyof OrderPaymentAttributesExt> = {
      trip: <any>"trip.id",
      /*status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",*/
      //creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "dateHour";
  }

  toggleDetails(trip: any): void {
    if (this.selectedPay && this.selectedPay.trip.id === trip.trip.id) {
      this.closeDetails();
      return;
    } else {
      this.selectedPay = trip;
      this.onFilterVisits(trip);
    }
  }

  closeDetails(): void {
    this.selectedDetail = null;
    this.selectedInner = null;
    this.selectedPay = null;
  }

  onClearFilter() {
    // this.onFilter()
  }

  // applyFilter(filterValue: string) {
  //   this.pageIndex = 1
  //   this.search = filterValue
  //   // this.onFilter()
  // }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    // this.onFilter()
  }

  clearFilters(): void {
    this.routeMultiCtrl.setValue([]);
    this.typeMultiCtrl.setValue([]);
    this.businessPartners.setValue([]);
    this.selectedCompanyIds = null;
    this.bankMultiCtrl.setValue([]);
    this.methodMultiCtrl.setValue([]);
    this.range.get('start').setValue(null);
    this.range.get('end').setValue(null);
    this.rangeTripStart.get('startTripStart').setValue(null);
    this.rangeTripStart.get('endTripStart').setValue(null);
    this.rangeTripEnd.get('startTripEnd').setValue(null);
    this.rangeTripEnd.get('endTripEnd').setValue(null);
    this.selectedERPStatuses = [];
    this.selectedStatuses = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onFilterVisits(element: any) {
    this.dataSourceDetail.data = [];
    this.dataSourceDetail.data = element.orders.sort((a, b) => {
      if (a.serials < b.serials) {
        return -1;
      } else if (a.serials > b.serials) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  onFilterDetail(detail?: any) {
    this.dataSourceInnerDetail.data = [];
    this.dataSourceInnerDetail.data = this.groupOrders(detail.shipDetail);
    this.dataSourceDocument.data = detail.shipDetail
      .map((d) => d.orders)
      .flat();
  }

  groupOrders(data): any {
    let groupedDataSource = data.reduce((result, item) => {
      const key = `${item.bank}|${item.paymentType}|${item.operationNumber}`;

      if (!result[key]) {
        result[key] = {
          id: key,
          bank: item.bank,
          accountNumber: item.accountNumber,
          orders: [],
          paymentType: item.paymentType,
          operationNumber: item.operationNumber,
          paying: 0,
        };
      }

      result[key].orders.push(...item.orders);
      result[key].paying += item.totalAmount;

      return result;
    }, {});

    let dataSource = Object.values(groupedDataSource);
    return dataSource;
  }

  onFilterDetailInner(detail?: any) {

    this.dataSourceShip.data = [];
    this.dataSourceShip.data = detail.orders;
  }

  openModal(element): void {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: element,
        requeriment: {
          approve: validateOrdersByActionForPayment([element], this.documentClassList, 'APPROVE'),
          approve_generate: validateOrdersByActionForPayment([element], this.documentClassList, 'APPROVE_GENERATE_NEXT'),
          reject: validateOrdersByActionForPayment([element], this.documentClassList, 'REJECT'),
        },
        type: TypeRejectEnum.DOCUMENTO_PAGO
      }, //'COBRANZA'
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
        if (result) {
          let sendCollection = {
            ids: element.shipDetail.map((e) => e.id),
            commentary: result.rejectedReason ?? null,
            reasonRejectionId: result.reasonRejectionId ?? null,
            paymentReview: result.approve ? 7 : 8,
          };

          if (result.approve) {
            sendCollection["paymentStatus"] = 0;  // Lo cambie porque el 0 es el estado de pendiente envio ERP, antes tenia 1 por eso se ve azul
          }

          this.updatePayment(element, sendCollection);
        }
      }
    });
    this.findAllWithCount();
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
      0;
  }

  validateDataToSynchronize(order: OrderPaymentAttributes) {
    return validateOrdersByActionForPayment([order], this.documentClassList, 'SYNC')
  }

  validateDataToAppOrRejected(order: OrderPaymentAttributes) {
    return validateOrdersByActionForPayment([order], this.documentClassList, 'APPROVE') ||
      validateOrdersByActionForPayment([order], this.documentClassList, 'REJECT')
  }

  // validateDataToSynchronize(order: OrderPaymentAttributes) {
  //   return (
  //     order?.paymentReview === 7 &&
  //     (order?.paymentStatus === undefined ||
  //       order?.paymentStatus === 1 ||
  //       order?.paymentStatus === 4)
  //   );
  // }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"}`;
  }

  isAllSelected() {
    const validRows = this.dataSourceDetail.data.filter((row) =>
      this.validateDataToSynchronize(row)
    );
    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected === numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSourceDetail.data.forEach((row) => {
        if (this.validateDataToSynchronize(row)) this.selection.select(row);
      });
  }

  synchronizeOrders(order: OrderPaymentAttributes) {
    let dataToSendPost = {
      serials: [],
    }

    if (order) {
      dataToSendPost.serials.push(order.serials);
    } else {
      this.selection.selected.forEach(o => {
        dataToSendPost.serials.push(o.serials);
      });
    }
    this.paymentIntegratorService.sincronize(dataToSendPost).subscribe({
      next: () => {
        this.findAllWithCount()
        this.snackBar.open('Registro sincronizado con éxito', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al sincronizar el registro', 'Cerrar', { duration: 3000 });
      }
    })
  }

  // updatePayment(element: any, result: any): void {

  //   this.paymentOrderService
  //     .update(element.shipDetail[0].id.toString(), result)
  //     .subscribe({
  //       next: () => {
  //         this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
  //           duration: 3000,
  //         });
  //         this.findAllWithCount();
  //     },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al actualizar el registro",
  //           "Cerrar",
  //           { duration: 3000 }
  //         );
  //       },
  //     });
  // }

  async updatePayment(element: any, result: any): Promise<void> {
    const selectedTripId = this.selectedPay?.trip?.id;

    try {
      await firstValueFrom(this.paymentOrderService
        .update(element.shipDetail[0].id.toString(), result));

      await this.findAllWithCount();

      this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
        duration: 3000,
      });

      if (selectedTripId) {
        const updatedTrip = this.dataSource.find(
          (t: any) => t.trip?.id === selectedTripId
        );

        if (updatedTrip) {
          this.selectedPay = JSON.parse(JSON.stringify(updatedTrip));
          this.onFilterVisits(this.selectedPay);
        }
      }

    } catch (error) {
      this.snackBar.open(
        error.error?.message || "Error al actualizar el registro",
        "Cerrar",
        { duration: 3000 }
      );
    }
  }

  onExportButtonPressed() {
    if (!this.orderPaymentListExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: ORDER_PAYMENT_LIST_TITLE,
      },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderPaymentListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  goToTravel(element: OrderPaymentAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(['monitor', 'principal-screen'], { queryParams });
      const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  toggleSelection(status: number): void {
    const index = this.selectedStatuses.indexOf(status);
    if (index === -1) {
      this.selectedStatuses.push(status);
    } else {
      this.selectedStatuses.splice(index, 1);
    }
    this.findAllWithCount();
  }

  isSelected(status: number): boolean {
    return this.selectedStatuses.includes(status);
  }

  // Métodos para estados ERP
  toggleERPSelection(status: number): void {
    const index = this.selectedERPStatuses.indexOf(status);
    if (index === -1) {
      this.selectedERPStatuses.push(status);
    } else {
      this.selectedERPStatuses.splice(index, 1);
    }
    this.findAllWithCount();
  }

  isERPSelected(status: number): boolean {
    return this.selectedERPStatuses.includes(status);
  }

  hasSelectedERPStatuses(): boolean {
    return this.selectedERPStatuses.length > 0;
  }

  // Métodos para obtener los objetos completos de los estados seleccionados
  getSelectedStatusObjects() {
    return this.statusOptions.filter(option =>
      this.selectedStatuses.includes(option.value))
  }

  getSelectedERPStatusObjects() {
    return this.erpStatusOptions.filter(option =>
      this.selectedERPStatuses.includes(option.value))
  }

  // Métodos para remover selecciones
  removeSelection(status: number): void {
    const index = this.selectedStatuses.indexOf(status);
    if (index >= 0) {
      this.selectedStatuses.splice(index, 1);
    }
  }

  removeERPSelection(status: number): void {
    const index = this.selectedERPStatuses.indexOf(status);
    if (index >= 0) {
      this.selectedERPStatuses.splice(index, 1);
    }
  }

  openLogModal(element:OrderPaymentAttributes){
    let dataToModal = {
      documentIdentifier: element.serials,
      type: element?.document_type?.code
    }
    this.dialog.open(LogModalComponent, {
      panelClass: ".form-modal-interlocutor",
      width: "90%",
      data: dataToModal,
      disableClose: true
    });
  }

  cobranzaPrintModes = [{
    value: 1,
    label: "Unico"
  }, 
  {
  value: 2,
  label: "Consolidado"
  }];

  printCollection(element): void {
    if (!element.shipDetail.length) {
      this.snackBar.open('No se encontró el ID de la cobranza', 'Cerrar', { duration: 3000 });
      return;
    }


    const hasMoreThanOneDetail = element?.shipDetail?.length > 1;

    this.selectedElement = element;
    this.collectionForm = this.fb.group({
      printMode: [hasMoreThanOneDetail ? 2 : 1, Validators.required],
      collectionId: [element?.shipDetail?.[0]?.id],
      landscape: [false, Validators.required],
    });

    this.dialog.open(this.collectionPdfDialog, { width:'50%', disableClose: true });
  }

  downloadCollection(): void {
    if (this.collectionForm.invalid) {
      this.snackBar.open('Completa todos los campos', 'Cerrar', { duration: 3000 });
      return;
    }

    const collectionFormRawValue = this.collectionForm.getRawValue();

    const options: InvoicePdfOptions = {
      format: 'letter',
      landscape: collectionFormRawValue.landscape,
      scale: 1,
      printBackground: true,
      marginTop: '10mm',
      marginBottom: '10mm',
      type: collectionFormRawValue.printMode
    };

    this.collectionService.downloadAndSaveCollection(collectionFormRawValue.collectionId, options).subscribe({
      next: () => {
        this.snackBar.open('Cobranza descargada correctamente', 'Cerrar', { duration: 3000 });
      },
      error: (error) => {
        this.snackBar.open(error.message || 'Error al imprimir la cobranza', 'Cerrar', { duration: 5000 });
      }
    });
  }
}